import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";

import { defaultTermsBookingStatus } from "../../../thunks/buyer-thunks/BuyerThunks";

const initialState = {
  isdefaultBookingLoading: false,
  defaultBooking: null,
  error: null,
};

export const defaultTermsBookingSlice = createSlice({
  name: "defaultBookingTerms",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(defaultTermsBookingStatus.pending, (state) => {
        state.isdefaultBookingLoading = true;
        state.error = null;
      })

      .addCase(defaultTermsBookingStatus.fulfilled, (state, action) => {
        state.isdefaultBookingLoading = false;
        state.defaultBooking = action.payload;
        state.error = null;

        message.success(action.payload?.message || "Success");
      })

      .addCase(defaultTermsBookingStatus.rejected, (state, action) => {
        state.isdefaultBookingLoading = false;
        state.defaultBooking = null;
        state.error = action.payload || action.error?.message;

        message.error("Something went wrong!");
      });
  },
});

export default defaultTermsBookingSlice.reducer;
